import { bootstrapApplication } from '@angular/platform-browser';
import * as Sentry from '@sentry/angular';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';
import { hostSentryInitOptions } from './app/core/error/runtime-sentry-env';

// The options (drops + FR-059 PII scrub) live in sentry-options.ts so a test can
// build a real client from exactly these (FR-059 U8 A1-G1).
// FR-075 AC-5.4: the environment (and DSN) the HOST declares in /runtime-config.js
// win over the baked ones — production serves the image staging built.
Sentry.init(hostSentryInitOptions(environment));

// TODO(REQ-4): Once auth lands, call Sentry.setUser({ id: <user.id> }) from
// the auth service after login. AC-4 requires only the anonymized id —
// never email, name, or IP.

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
